<template>
  <div class="form-group">
    <label>
      <span class="title" :style="'color: ' + titleColor">{{ title }} </span>
      <span class="required" v-if="required">*</span>
      <Tip :field="field" :formName="formName" />
    </label>
    <div class="inner-addon right-addon">
      <i v-if="notifications.length > 0 && formDirty" class="required glyphicon fas fa-exclamation-triangle"></i>
      <slot v-else></slot>
      <input type="password" :disabled="disabled" :placeholder="titlePlaceholder" v-mask="mask || withoutMask"
        v-bind:value="value" v-on:input="$emit('input', $event.target.value)" class="form-control"
        :class="{ required: notifications.length > 0 && formDirty }" />
    </div>
    <div v-if="formDirty">
      <div v-for="message in notifications" :key="message">
        <span class="invalid">{{ message }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Tip from "../shared/Tip.vue";
import { mapState, mapMutations } from "vuex";

export default {
  components: { Tip },
  name: "InputPassword",
  mixins: [],
  props: [
    "title",
    "field",
    "titleColor",
    "placeholder",
    "disabled",
    "mask",
    "formName",
    "required",
    "maxLength",
    "value",
  ],
  data() {
    return {
      notifications: [],
      formDirty: false,
      withoutMask: {
        mask: "*".repeat(255),
        tokens: {
          "*": { pattern: /./ },
        },
      },
    };
  },
  created() {
    this.validate();
  },
  methods: {
    ...mapMutations("validation", [
      "addValidation",
      "removeValidation",
      "updateFormDirty",
    ]),
    validate() {
      this.notifications = [];

      if (this.required && this.value.length == 0) {
        var message = `${this.title} não pode ser vazio!`;
        this.notifications.push(message);
      }

      if (this.maxLength > 0) {
        if (this.value.length > this.maxLength) {
          var message = `Máximo de ${this.maxLength} caracteres!`;
          this.notifications.push(message);
        }
      }
    },
  },
  computed: {
    ...mapState("validation", ["resetForm", "validations"]),
    titlePlaceholder() {
      return "Digite a " + this.title;
    },
  },
  watch: {
    value() {
      this.validate();
      this.formDirty = true;
      this.updateFormDirty(true);
    },
    notifications() {
      let self = this;
      this.notifications.forEach(function (notification) {
        let obj = {
          key: self.field + "&" + self.formName,
          formName: self.formName,
          notification: notification,
        };
        self.addValidation(obj);
      });

      if (this.notifications.length == 0) {
        let obj = {
          key: self.field + "&" + self.formName,
          formName: self.formName,
        };
        self.removeValidation(obj);
      }
    },
    resetForm: {
      handler(form) {
        if (form.name == this.formName) this.formDirty = false;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #0a0a0a;
  letter-spacing: 0.5px !important;
}

input::placeholder {
  font-weight: 300 !important;
  opacity: 0.5;
  color: #969595;
}

.success {
  color: #94aa2a;
  font-size: 14px;
}

.invalid {
  color: #f0134d;
  font-size: 14px;
}

.margin-button {
  margin-top: -10px;
}
</style>
